import { render, staticRenderFns } from "./AddAccountantPage.vue?vue&type=template&id=28a3b90e"
import script from "./AddAccountantPage.vue?vue&type=script&lang=js"
export * from "./AddAccountantPage.vue?vue&type=script&lang=js"
import style0 from "./AddAccountantPage.vue?vue&type=style&index=0&id=28a3b90e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports